module.exports = __webpack_public_path__ + "static/img/3.40e2c1c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/6/zh/3.png
// module id = 4o20
// module chunks = 0